import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";

interface IKYCModalActionButtonsProps {
  onSubmit: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
  cancelButtonText?: string;
  submitButtonText?: string;
  hideCancelButton?: boolean;
}

export const KYCModalActionButtons: React.FC<IKYCModalActionButtonsProps> = ({
  onSubmit,
  onCancel,
  isLoading,
  cancelButtonText,
  submitButtonText,
  hideCancelButton = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 items-end">
      <div className="flex w-full flex-row gap-3 border-t border-grey-light px-4 pt-6 md:px-0">
        {!hideCancelButton && (
          <Button className="w-full" variant="secondary" onClick={onCancel}>
            {cancelButtonText ?? t("KYC.modal.buttons.cancel")}
          </Button>
        )}
        <Button className="w-full" onClick={onSubmit} isLoading={isLoading}>
          {submitButtonText ?? t("KYC.modal.buttons.submit")}
        </Button>
      </div>
    </div>
  );
};
